import React from 'react';
import './styles/index.scss';
import { AppRouting } from 'app/routing';

function App() {
  return (
    <AppRouting />
  );
}

export default App;
